import React from 'react'
import { Row } from 'react-sticky-table'
import styled from 'styled-components'

export interface Props {
  children: React.ReactNode
  disabled?: boolean
}

const RowStyled = styled(Row)`
  ${props => (props.disabled ? 'pointer-events: none; opacity: 0.5;' : '')}
`

export function TableRow({ children, ...others }: Props) {
  return (
    <RowStyled {...others} head role='row'>
      {children}
    </RowStyled>
  )
}
